<h2 mat-dialog-title>
  {{ 'LIB_ORDERS.SALES_ORDERS.SUBMIT_ORDER_FOR_APPROVAL.SELECT' | translate }}
</h2>

<mat-dialog-content>
  <div *ngIf="warningMessage">
    <glxy-alert type="warning">
      <strong>{{ warningMessage }}</strong>
    </glxy-alert>
  </div>

  <div class="expiry-hint-message">{{ 'LIB_ORDERS.SALES_ORDERS.ADD_EXPIRY_HINT' | translate }}</div>

  <orders-associate-user-to-order />

  <div class="expiry-actions">
    <glxy-form-field>
      <glxy-label>{{ 'LIB_ORDERS.SALES_ORDERS.ADD_EXPIRY' | translate }}</glxy-label>
      <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" [formControl]="expiryDateControl" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      @if (expiryDateControl.invalid && expiryDateControl.touched) {
        <mat-error>
          <glxy-error>{{ 'LIB_ORDERS.SALES_ORDERS.ADD_EXPIRY_ERROR' | translate }}</glxy-error>
        </mat-error>
      }
    </glxy-form-field>
  </div>
  @if (canCollectPaymentFromCustomer) {
    <div
      (mouseenter)="showPopovers(hasAlreadyActiveProducts, PopoverPositions.TopLeft)"
      (mouseleave)="hidePopovers()"
      [glxyPopover]="popover"
    >
      <mat-checkbox color="primary" [(ngModel)]="shouldCollectPayment" [disabled]="hasAlreadyActiveProducts">
        <div class="checkbox-text">
          {{ 'LIB_ORDERS.SALES_ORDERS.REQUIRE_CUSTOMER_PAYMENT' | translate }}
          <div class="hint">{{ 'LIB_ORDERS.SALES_ORDERS.REQUIRE_CUSTOMER_PAYMENT_HINT' | translate }}</div>
        </div>
      </mat-checkbox>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions">
    @if (!!data.openOrderPreviewDialog) {
      <button mat-stroked-button (click)="openOrderPreviewDialog()">
        {{ 'LIB_ORDERS.COMMON.ACTION_LABELS.PREVIEW' | translate }}
      </button>
    }
    <span>
      <button mat-stroked-button mat-dialog-close>
        {{ 'LIB_ORDERS.COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="success()" [disabled]="invalid">
        {{ 'LIB_ORDERS.COMMON.ACTION_LABELS.SEND' | translate }}
      </button>
    </span>
  </div>
</mat-dialog-actions>

<glxy-popover #popover [isOpen]="showPopover" [positions]="[this.position]">
  {{ 'LIB_ORDERS.COMMON.ORDERS.ALREADY_ACTIVE_POPOVER' | translate }}
</glxy-popover>
